import React from 'react';
import {of} from 'rxjs';
import {tap} from 'rxjs/operators';

import ajax from 'iss/utils/ajax';
import subscribeTo from 'iss/utils/subscriptionUtils';

export const contractSuppliers = ajax.cache("/contract-suppliers", 10 * ajax.MINUTES);

export function getContractSuppliers() {
  return contractSuppliers;
}

export function getContractSupplier(contractSupplierId) {
  return ajax.getJson("/contract-suppliers/"+contractSupplierId);
}

export function createContractSupplier(contractSupplierCreateCommand) {
  return ajax.postJson("/contract-suppliers", contractSupplierCreateCommand)
    .pipe(tap(contractSuppliers.clearCache));
}

export function modifyContractSupplier(contractSupplierId, contractSupplierCreateCommand) {
  return ajax.putJson("/contract-suppliers/"+contractSupplierId, contractSupplierCreateCommand)
    .pipe(tap(contractSuppliers.clearCache));
}

export function deleteContractSupplier(contractSupplierId) {
  return ajax.deleteJson("/contract-suppliers/"+contractSupplierId, undefined, {resultType: 'text'});
}

export function searchContractSuppliers(searchTerm, page, pageSize, showLoadingScreen = true, showOnlyPreferred = true) {
  const encodedSearch = encodeURIComponent(searchTerm);
  return ajax.getJson(
    `/contract-suppliers/search?searchTerm=${encodedSearch}&page=${page}&size=${pageSize}&showOnlyPreferred=${showOnlyPreferred}`,
    {showLoadingScreen}
  );
}

export function subscribeToContractSupplier(WrappedComponent) {
  return function ContractSupplierEditor({supplierId, ...props}) {
    let supplierObservable = supplierId ?
    getContractSupplier(supplierId) :
      of({
            id: 0,
            businessId: null,
            name: null,
            description: null,
            serviceInformation: null,
            otherInformation: null,
            contactPerson: null,
            email: null,
            area: null,
            preferredSupplier: false,
            category: null,
            isActice: true
      });

    const SubscribedComponent = subscribeTo(supplierObservable, 'supplier', WrappedComponent);

    return <SubscribedComponent {...props} />;
  };
}



// WEBPACK FOOTER //
// ./modules/issFrontend/service/ContractSuppliersService.js